export default {
  OPTUM: "optum",
  UHC: "uhc"
};
